export default __webpack_public_path__ + "static/media/021-ganesha.36264169.svg";